import "./BadgeNew.scss";
import { ReactComponent as StarIcon } from "shared/assets/images/icon-star.svg";

interface BadgeNewProps {
  text: string;
  style?: React.CSSProperties;
}

const BadgeNew: React.FC<BadgeNewProps> = ({ text, style }) => {
  return (
    <div className="badge-new" style={{ ...style }}>
      <div className="container">
        <StarIcon stroke="#F680C8" width={14} height={14} />
        <span className="text">{text}</span>
      </div>
    </div>
  );
};

export default BadgeNew;
